import { ProfileModel } from '@/http/models/Profile'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { ProfileHttpParams } from '@/types/http-params/ProfileHttpParams'

export const useUpdateProfile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: ProfileHttpParams.Update['body']) => ProfileModel.update({ body }),
    onSuccess: (response) => {
      if (response.success) {
        toast.success('Profile updated successfully')
        queryClient.invalidateQueries({ queryKey: ['profile'] })
      } else {
        toast.error(response.error?.data?.message || 'Failed to update profile')
      }
    },
    onError: (error: any) => {
      toast.error(error.message || 'Something went wrong')
    },
  })
}
